var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('p',{staticClass:"title font-weight-light short-description mt-2 text-styles",domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }